const shareMixin = {
  methods: {
    copyLink: function () {
      navigator.clipboard.writeText(window.location.href);
      (this as any).$store.dispatch(
        'alert/success',
        'Link copied to clipboard.'
      )
    }
  }
};

export default shareMixin;
